export var WidthConstraint;
(function (WidthConstraint) {
    WidthConstraint["WIDTH_CONSTRAINT_UNKNOWN"] = "WIDTH_CONSTRAINT_UNKNOWN";
    WidthConstraint["FULL_WIDTH"] = "FULL_WIDTH";
    WidthConstraint["THREE_QUARTERS_WIDTH"] = "THREE_QUARTERS_WIDTH";
    WidthConstraint["TWO_THIRDS_WIDTH"] = "TWO_THIRDS_WIDTH";
})(WidthConstraint || (WidthConstraint = {}));
